import { BenefitsPage as Props } from '../../types';
import ListingTemplate from './ListingTemplate';
import BenefitsList from '../BenefitsList';

const BenefitsPage = ({ data, ...post }: Props) => (
  <ListingTemplate {...post}>
    <BenefitsList benefits={data?.benefits || []} />
  </ListingTemplate>
);

export default BenefitsPage;
